import SentimentSatisfiedOutlinedIcon from '@mui/icons-material/SentimentSatisfiedOutlined';
import SentimentVeryDissatisfiedOutlinedIcon from '@mui/icons-material/SentimentVeryDissatisfiedOutlined';
import SentimentVerySatisfiedOutlinedIcon from '@mui/icons-material/SentimentVerySatisfiedOutlined';
import React from 'react';

export const StatusEmote = ({ code }) => {
  return (
    <>
      {code === 'ACTIVE' ? (
        <SentimentVerySatisfiedOutlinedIcon
          htmlColor="green"
          fontSize="large"
        />
      ) : null}
      {code === 'WAITING_DEPLOY' ? (
        <SentimentSatisfiedOutlinedIcon htmlColor="orange" fontSize="large" />
      ) : null}
      {code === 'DEPLOYING' ? (
        <SentimentVeryDissatisfiedOutlinedIcon
          htmlColor="red"
          fontSize="large"
        />
      ) : null}
    </>
  );
};
